// Imports
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from '@tippyjs/react';
import { darken } from 'polished';
import styled from 'styled-components/macro';
import LinkButton from '../../../../../../shareables/foundation/front-end/components/buttons/link';
import tippyProps from '../../../../../../shareables/foundation/front-end/utils/tippy-props';
import { GetPaymentOptionsResponse } from '../../../../../../shareables/types/api/main/website/payment-options/get';
import { GeneratedThemeProps } from '../../../../../templates/template-style';


// Styled components
const View = styled(LinkButton)<{ theme: GeneratedThemeProps }>`
	background-color: ${(props) => props.theme.baseColor};
	
	&:hover,
	&:focus {
		background-color: ${(props) => darken(0.05, props.theme.baseColor)} !important;
	}
`;


// Define the accepted props
interface Props {
	paymentOption: GetPaymentOptionsResponse[0];
}


// Function component
const PaymentOptionRow: React.FC<Props> = ({ paymentOption }) => {
	// Return JSX
	return (
		<tr>
			<td>{paymentOption.title}</td>
			
			<td style={{ textAlign: 'center' }}>
				<Tippy {...tippyProps} content='View this payment option'>
					<View to={`pay?id=${paymentOption.id}`} aria-label={`View “${paymentOption.title}”`} smaller>
						<FontAwesomeIcon icon={faChevronRight} />
					</View>
				</Tippy>
			</td>
		</tr>
	);
};

export default PaymentOptionRow;
